import { User } from "../models/user";
import { CompanyFile } from "../models/company-file";
import { CompanyStatus } from "../models/company-status";
import { CompanyLicense } from "../models/company-license";
import { Country } from "../models/country";
import { CompanyContact } from "../models/company-contact";
import { CompanyBuildingUnitView } from "../models/company-building-unit-view";

export class Company  {
  public id: number;
  public name: string;
  public applicationNumber: string;
  public companyTypeId: number;
  public companyStatusId: number;
  public countryOfOriginId: number;
  public ftePermittedCount: number;
  public fteCurrentCount: number;
  public fteBufferPercentage: number;
  public fteMaxCount: number;
  
  public leaseIssuanceDate: string;
  public leaseExpiryDate: string;
  public officeLocation: string;
  public companyProfile: string;
  public companyMission: string;
  public logo: string;
  public companyAddress: string;
  public companyWebsiteUrl: string;
  public hostCompanyId: number;
  public companyTypeName: string;
  public companyStatusName: string;
  public countryOfOriginName: string;
  public projectId: string;
  //New Licensee Manager 
  public user: User;

  //Current Licensee Manager 
  public currentLicenseeManager: User;

  //Company Users
  public companyUsers: User[];

  //Files
  public files: CompanyFile[]

  //Logo file
  public logoFile: CompanyFile = new CompanyFile();

  //Company Status
  public companyStatus: CompanyStatus = new CompanyStatus();

  //Company License
  public companyLicense: CompanyLicense = new CompanyLicense();


  //Contacts
  public companyContacts: CompanyContact[];

  public companyBuildingUnitsList: CompanyBuildingUnitView[];
}



// WEBPACK FOOTER //
// ./src/app/core/models/company.ts